import { Modal } from '@mui/base';
import { Backdrop, Dialog } from '@mui/material';
import Player, { PlayerProps } from "./player";
interface VideoPlayerProps extends PlayerProps {
  // for isEmbed = true
  previewSlot?: React.ReactNode;
  embedWrapperStyle?: React.CSSProperties
  customContainerStyle?: React.CSSProperties
}

const VideoPlayer = (props: VideoPlayerProps) => {
  return props.isEmbed ? (
    props.open ? (
      <div className="embedWrapper" style={props.embedWrapperStyle}>
        <div className="customContainer" style={props.customContainerStyle}>
          <Player {...props} />
        </div>
      </div>
    ) : (
      props.previewSlot && props.previewSlot
    )
  ) : (
    <Dialog
    open={props.open}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
    className="videoModal"
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        style: {
          zIndex: 999,
        }
      }
    }}
    onClose={()=>{props.handleClose?.()}}
  >
    <Player {...props} />
  </Dialog>
  )
}

export default VideoPlayer;